import {
  mapGetters,
} from 'vuex';

import europeanUnionIcon from '@/assets/images/icons/european-union.svg';


export default {
  name: 'Title',
  components: {
    europeanUnionIcon,
  },
  props: {
    title: '',
    previousStepTitle: '',
    customPreviousStep: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({

  }),
  computed: {
    ...mapGetters('appointment', {
      licensePlate: 'getLicensePlate',
    }),
  },
  methods: {
    handleGoToPreviousStep() {
      if (this.customPreviousStep) {
        this.$emit('on-go-to-previous-step');
      } else {
        this.$router.go(-1);
      }
    },
  },
};
